import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text_btns" }
const _hoisted_2 = { class: "operation-wrapper" }

import { computed, onMounted, ref, Ref, watch } from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import AddEditComponent from '@/components/SmartLink/admincomponents/AddEditComponent.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER, ALLHEADER, } from '@/interfaces/SmartLink/Tables';
import { GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';

/**
 * Ancho del dialogo, dependiendo del dispositivo donde se ve
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
const {xs, md,smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
const width = computed(() => md.value?'60%':smAndDown.value?'85%':'900px');

/**
 * CREO que sirve para buscar según que columnas
 */
const searchField = ref();

/**
 * Busca dentro de la tabla el valor que se escribe aquí
 */
const searchValue = ref("");

/**
 * Mostrar el Dialogo
 */
const dialog = ref(false);

const headers: Ref<HEADER[]> = ref([]);

const HEADERS_ADMIN:ALLHEADER = {
    header : [
        { text: computed(()=> t('labels.name')),        value: "tag",           sortable: true },
        { text: computed(()=> t('labels.ip')),          value: "ip",            sortable: true },
        { text: computed(()=> t('labels.mark')),        value: "marca",         sortable: true },
        { text: computed(()=> t('labels.subtype')),     value: "rol",           sortable: true },
        { text: computed(()=> t('labels.type')),        value: "tipo",          sortable: true },
        { text: computed(()=> t('labels.snmp_conf')),   value: "snmp_conf",     sortable: true },
        { text: computed(()=> t('labels.annotation')),  value: "anotacion",     sortable: true },
        { text: computed(()=> t('labels.location')),    value: "gps",           sortable: true },
        { text: computed(()=> t('labels.operation')),   value: "operation",     sortable: false},
    ]
}

/**
 * Todo el inventario que es traido desde la STORE 
 * API: "inventario"
 */
let items   = computed(()=>store.state.arrayListItems);

/**
 * Objeto que inicializa el dialog al seleccionar alguna fila de la tabla
 */
const objectItem:Ref<GENERAL_EQUIPAMENT>    = ref({
    elemid      : 0,
    tag         : '',
    ip          : '',
    marca       : '',
    rol         : '',
    tipo        : '',
    snmp_config : '0',
    anotacion   : '{}',
    gps         : JSON.stringify({latitud: 0, longitud: 0, altitud: 0}),
})

/**
 * Darle click al boton AGREGAR, abrira el dialog y agregara al objeto
 * "objectItem", el tipo de dialogo, en este caso: 'ADD'
 */
function showAddDialog() { 
    objectItem.value['typeDialog']  = 'add';
    dialog.value                    = true;
}

/**
 * Darle click al boton EDITAR (lapiz), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'EDIT'. 
 */
function showEditDialog(item:GENERAL_EQUIPAMENT){
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'edit';
    dialog.value                    = true;
}

/**
 * Darle click al boton BORRAR (tacho), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'DELETE'. 
 */
function showDeleDialog (item:GENERAL_EQUIPAMENT) { 
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'delete';
    dialog.value                    = true;
}

/**
 * Cierra el Diálogo cambiando el valor del dialog a FALSE
 */
function closeDialog(){
    dialog.value    = false;            
}

/**
 * Cuando se cierra cualquier dialog, el objeto "objectItem"
 * regresa a su forma original
 */
function resetValues(){
    objectItem.value =  {
        elemid      : 0,
        tag         : '',
        ip          : '',
        marca       : '',
        rol         : '',
        tipo        : '',
        snmp_config : '0',
        anotacion   : '{}',
        gps         : JSON.stringify({latitud: 0, longitud: 0, altitud: 0}),
    }
}

/**
 * Cuando el valor de "dialog" es falso, llama a la funcion: "resetValues()"
 */
watch(dialog, (item) => {
    if (!item) {
        resetValues()
    }
})

onMounted(async()=>{
    headers.value = HEADERS_ADMIN['header']
    
    /**
     * Realiza el llamado a la STORE, para realizar la ACCION: "getInventoryData",
     * el cual hace un llamado a la API.
     */
    await store.dispatch('getInventoryData');
    resetValues();
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "bgtopology",
    class: "adminview ma-4 pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "space-between",
        class: "pb-6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "px-6",
            cols: "12",
            sm: "4",
            md: "3",
            lg: "3",
            xl: "2",
            "align-self": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                block: "",
                color: "success",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddDialog()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('buttons.add')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: "ma-0",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "px-6 pt-0",
                cols: "12",
                sm: "12",
                md: "9",
                lg: "9",
                xl: "10",
                "align-self": "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "ma-0",
                    style: {"width":"100%"},
                    justify: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        style: _normalizeStyle(!_unref(xs) ? 'max-width: 400px !important; margin-top: 10px':'padding-top: 10px !important'),
                        modelValue: searchValue.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                        label: _unref(t)('search'),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": ""
                      }, null, 8, ["style", "modelValue", "label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
        width: width.value
      }, {
        default: _withCtx(() => [
          _createVNode(AddEditComponent, {
            itemObject: objectItem.value,
            onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (closeDialog()))
          }, null, 8, ["itemObject"])
        ]),
        _: 1
      }, 8, ["modelValue", "width"]),
      _createVNode(_component_EasyDataTable, {
        "search-field": searchField.value,
        "search-value": searchValue.value,
        "table-class-name": "customize-table",
        "show-index": "",
        headers: headers.value,
        items: _unref(items)
      }, {
        "item-operation": _withCtx((item) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_icon, {
              color: "blue",
              onClick: ($event: any) => (showEditDialog(item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" mdi-pencil-plus ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_v_icon, {
              color: "red",
              onClick: ($event: any) => (showDeleDialog(item))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" mdi-delete ")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["search-field", "search-value", "headers", "items"])
    ]),
    _: 1
  }))
}
}

})